var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-end mb-2"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v(" + Add Trip Document ")])], 1), _c('b-table', {
    staticStyle: {
      "min-height": "400px"
    },
    attrs: {
      "items": _vm.value,
      "fields": _vm.fields,
      "small": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(index)",
      fn: function fn(_ref) {
        var index = _ref.index;
        return [_vm._v(_vm._s(index + 1))];
      }
    }, {
      key: "cell(file)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.fileUrl ? _c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": function click($event) {
              return _vm.openTripDoc(item);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Download ")]) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(_ref3) {
        var index = _ref3.index;
        return [_c('b-dropdown', {
          attrs: {
            "right": "",
            "size": "sm",
            "text": "Action",
            "variant": "outline-primary"
          }
        }, [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.edit(index);
            }
          }
        }, [_vm._v("Edit")]), _c('b-dropdown-item', {
          staticClass: "text-danger",
          on: {
            "click": function click($event) {
              return _vm.remove(index);
            }
          }
        }, [_vm._v(" Delete ")])], 1)];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "title": "Trip Document"
    },
    on: {
      "ok": _vm.save
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Document Name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: _vm.form.documentName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "documentName", $$v);
      },
      expression: "form.documentName"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Detail Trip Number"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.detailTripOptions,
      "placeholder": "Select detail trip number"
    },
    model: {
      value: _vm.form.detailTripNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "detailTripNumber", $$v);
      },
      expression: "form.detailTripNumber"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "File"
    }
  }, [_c('b-form-file', {
    attrs: {
      "accept": ".pdf,.jpg,.png"
    },
    model: {
      value: _vm.form.file,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "file", $$v);
      },
      expression: "form.file"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }